import React from 'react';
import { Form, Switch } from 'antd';
import type { FormItemProps } from 'antd';

type ActiveStatusFormItemProps = Omit<FormItemProps, 'valuePropName' | 'children'> & {
  disabled?: boolean;
};

const ActiveStatusFormItem: React.FC<ActiveStatusFormItemProps> = ({
  disabled,
  label = 'Status',
  ...formItemProps
}) => (
  <Form.Item label={label} valuePropName="checked" {...formItemProps}>
    <Switch
      checkedChildren="Active"
      unCheckedChildren="Inactive"
      disabled={disabled}
    />
  </Form.Item>
);

export default ActiveStatusFormItem;